import * as Yup from "yup";
import { Formik, Form } from "formik";
import { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";

import { useTranslation } from "react-i18next";

import _ from "lodash";
import moment from "moment";

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiButton from "components/SuiButton";
import SuiSelect from "components/SuiSelect";
import FormikFormField from "components/FormikFormField";
import FormikFormFieldPassword from "components/FormikFormFieldPassword";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import { AdminUser } from "api";
import { Auth } from "api";

function NewOrEditAdminUser({mode}) {
  const { t } = useTranslation();
  const { id } = useParams();
  const isEditing = !!id;
  const TITLE = t(isEditing ? "Edit Admin User" : "New Admin User");
  const history = useHistory();
  const [adminUser, setAdminUser] = useState({});
//   const [adminUserHistory, setAdminUserHistory] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedStatus, setSelectedStatus] = useState();

  const [selectedDepartment, setSelectedDepartment] = useState();
  const [selectedPosition, setSelectedPosition] = useState();

  const statusOptions = [
    { value: "active", label: t("Active") },
    { value: "inactive", label: t("Inactive") },
  ];

  const departmentOptions = [
    { value: "IT", label: t("IT") },
    { value: "Marketing", label: t("Marketing") },
    { value: "CS", label: t("CS") },
    { value: "Admin", label: t("Admin") },
  ];

  const positionOptions = [
    { value: "Manager", label: t("Manager") },
    { value: "Staff", label: t("Staff") },    
  ];

  const { loginEmail, lastName, firstName, password, confirmPassword , mobile, department, position, status } = {
    loginEmail: {
        name: "loginEmail",
        label: t("Login Email"),
        type: "email",
        placeholder: t("Login Email"),
        invalidMsg: t("Your email address is invalid"),
        errorMsg: t("Login email is required")
    },
    lastName: {
      name: "lastName",
      label: t("Last Name"),
      type: "text",
      placeholder: t("Last Name"),
      errorMsg: t("Last name is required"),
    },
    firstName: {
      name: "firstName",
      label: t("First Name"),
      type: "text",
      placeholder: t("First Name"),
      errorMsg: t("First name is required"),
    },
    password: {
        name: "password",
        label: t("Password"),
        type: "password",
        placeholder: t("Password"),
        errorMsg: t("Password is required"),
        invalidMsg: t("Password not match with confirm password")
      },
    confirmPassword: {
        name: "confirmPassword",
        label: t("Confirm Password"),
        type: "password",
        placeholder: t("Confirm Password"),
      },
    mobile: {
      name: "mobile",
      label: t("Mobile Number"),
      type: "text",
      placeholder: t("Mobile number"),
      invalidMsg: t("Mobile number is invalid"),
    },
    department: {
      name: "department",
      label: t("Department"),
      type: "text",
      placeholder: t("Choose a Department"),
    },
    position: {
        name: "position",
        label: t("Position"),
        type: "text",
        placeholder: t("Choose a Position"),
        
    },
    status: {
      name: "status",
      label: t("Status"),
      type: "select",
      placeholder: t("Choose a status"),
      errorMsg: t("Status is required"),
    },
  };

  const [initialValues, setInitialValues] = useState({
    [firstName.name]: "",
    [lastName.name]: "",
    [password.name]: "",
    [confirmPassword.name]: "",
    [mobile.name]: "",
    [loginEmail.name]: "",
    [department.name]: "",
    [position.name]: "",
    [status.name]: "",
  });

  const currentValidation = 
  isEditing ? 
  Yup.object().shape({
    [firstName.name]: Yup.string().required(firstName.errorMsg),
    [lastName.name]: Yup.string().required(lastName.errorMsg),
    [password.name]: Yup.string(),
    [confirmPassword.name]: Yup.string().oneOf([Yup.ref(password.name)], 'Passwords do not match'),
    [mobile.name]: Yup.string(),
    [loginEmail.name]: Yup.string().required(loginEmail.errorMsg).email(loginEmail.invalidMsg),
    [department.name]: Yup.string(),
    [position.name]: Yup.string(),
    [status.name]: Yup.string().required(status.errorMsg),
  })
  : 
  Yup.object().shape({
    [firstName.name]: Yup.string().required(firstName.errorMsg),
    [lastName.name]: Yup.string().required(lastName.errorMsg),
    [password.name]: Yup.string().required(password.errorMsg),
    [confirmPassword.name]: Yup.string().oneOf([Yup.ref(password.name)], 'Passwords do not match'),
    [mobile.name]: Yup.string(),
    [loginEmail.name]: Yup.string().required(loginEmail.errorMsg).email(loginEmail.invalidMsg),
    [department.name]: Yup.string(),
    [position.name]: Yup.string(),
    [status.name]: Yup.string().required(status.errorMsg),
  })
  ;

  useEffect(() => {
    if (!isEditing) return;
    (async () => {
      setIsLoading(true);
      try {
        const promises = await Promise.allSettled([AdminUser.get(id)]);
        const [adminUserData] = promises;
        setAdminUser(adminUserData.value.data);
        
      } catch (err) {
        console.error(err);
      }
      setIsLoading(false);
    })();
  }, []);

  useEffect(() => {
    if (!isEditing) return;
    setInitialValues({
      [firstName.name]: adminUser.firstName,
      [lastName.name]: adminUser.lastName,
      //[password.name]: adminUser.password,
      [mobile.name]: adminUser.mobile || "",
      [loginEmail.name]: adminUser.loginEmail || "",
      [department.name]: adminUser.department || "",
      [position.name]: adminUser.position || "",
      [status.name]: adminUser.status,
    });
    setSelectedDepartment(_.first(departmentOptions.filter((o) => o.value === adminUser.department)));
    setSelectedPosition(_.first(positionOptions.filter((o) => o.value === adminUser.position)));
    setSelectedStatus(_.first(statusOptions.filter((o) => o.value === adminUser.status)));
  }, [adminUser]);

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <DashboardLayout>
        <DashboardNavbar />
        <SuiBox my={1.5}>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={isEditing ? 9 : 12}>
            {(!isEditing || (isEditing && !isLoading)) && (
                <Formik
                initialValues={initialValues}
                validationSchema={currentValidation}
                onSubmit={async (values) => {
                  try {
                    const { firstName, lastName, password, mobile, loginEmail, department, position, status } = values; // eslint-disable-line
                    const data = {
                      firstName,
                      lastName,
                      password,
                      mobile: mobile || undefined,
                      loginEmail: loginEmail || undefined,
                      department: department || undefined,
                      position: position || undefined,
                      status:
                        status === "pending" || status === "unsubscribed"
                          ? undefined
                          : status,
                    };
                    if (isEditing) {
                      await AdminUser.update({ id, ...data });
                    } else {
                      await AdminUser.create(data);
                    }
                    history.goBack();
                  } catch (e) {
                    console.error(e);
                  }
                }}
              >
                {({ values, errors, touched, setFieldValue, submitForm }) => {
                const {
                  firstName: firstNameV,
                  lastName: lastNameV,
                  password: passwordV,
                  confirmPassword: confirmPasswordV,
                  mobile: mobileV,
                  loginEmail: loginEmailV,
                  department: departmentV,
                  position: positionV,
                  status: statusV,
                } = values;
                return (
                  <Form autoComplete="off">
              <Card style={{ overflow: "visible" }}>
                <SuiBox p={3}>
                  <SuiTypography variant="h5">{TITLE}</SuiTypography>
                  {/* <SuiTypography variant="button" fontWeight="regular" color="text">
                    {isEditing ? "Edit" : "Create"} admin user
                  </SuiTypography> */}
                  <Divider />
                  
                    
                      
                            <SuiBox>
                              <Grid container>
                                <Grid item xs={12}>
                                  <FormikFormField
                                    type={loginEmail.type}
                                    label={loginEmail.label}
                                    name={loginEmail.name}
                                    disabled={mode === "view"}
                                    value={loginEmailV}
                                    placeholder={loginEmail.placeholder}
                                    error={errors.loginEmail && touched.loginEmail}
                                    success={loginEmailV.length > 0 && !errors.loginEmail}
                                  />
                                  <FormikFormField
                                    type={firstName.type}
                                    label={firstName.label}
                                    name={firstName.name}
                                    disabled={mode === "view"}
                                    value={firstNameV}
                                    placeholder={firstName.placeholder}
                                    error={errors.firstName && touched.firstName}
                                    success={firstNameV.length > 0 && !errors.firstName}
                                  />
                                  <FormikFormField
                                    type={lastName.type}
                                    label={lastName.label}
                                    name={lastName.name}
                                    value={lastNameV}
                                    disabled={mode === "view"}
                                    placeholder={lastName.placeholder}
                                    error={errors.lastName && touched.lastName}
                                    success={lastNameV.length > 0 && !errors.lastName}
                                  />
                                  <FormikFormFieldPassword
                                    type={password.type}
                                    label={password.label}
                                    name={password.name}
                                    disabled={mode === "view"}
                                    value={passwordV}
                                    placeholder={password.placeholder}
                                    error={errors.password && touched.password}
                                    // success={passwordV.length > 0 && !errors.password}
                                  />
                                  <FormikFormFieldPassword
                                    type={confirmPassword.type}
                                    label={confirmPassword.label}
                                    disabled={mode === "view"}
                                    name={confirmPassword.name}
                                    value={confirmPasswordV}
                                    placeholder={confirmPassword.placeholder}
                                    error={errors.confirmPassword && touched.confirmPassword}
                                    // success={passwordV.length > 0 && !errors.password}
                                  />
                                  <FormikFormField
                                    type={mobile.type}
                                    label={mobile.label}
                                    name={mobile.name}
                                    disabled={mode === "view"}
                                    value={mobileV}
                                    placeholder={mobile.placeholder}
                                    error={errors.mobile && touched.mobile}
                                    success={mobileV.length > 0 && !errors.mobile}
                                  />                                  
                                  
                                  {mode=="view" && (
                                  <FormikFormField
                                    type="text"
                                    label={status.label}
                                    name={status.name}
                                    disabled={mode === "view"}
                                    value={t(statusV)}
                                  />
                                  )}                                  
                                  {mode!="view" &&
                                  (
                                  <FormikFormField
                                    label={status.label}
                                    name={status.name}
                                    value={selectedStatus}
                                    disabled={mode === "view"}
                                    component={SuiSelect}
                                    defaultValue={statusV}
                                    options={statusOptions}
                                    onChange={(option) => {
                                      setSelectedStatus(option);
                                      setFieldValue(status.name, option.value);
                                    }}
                                  />
                                  )}
                                </Grid>
                                
                              </Grid>
                            </SuiBox>
                          
                    
                  
                </SuiBox>
              </Card>
              <br/>
              <Card style={{ overflow: "visible" }}>
                <SuiBox p={3}>
                  {/* <SuiTypography variant="h5">Department</SuiTypography> */}
                  <SuiTypography variant="button" fontWeight="regular" color="text">
                    {t("Department")}
                  </SuiTypography>
                  <Divider />
                  <SuiBox>
                    <Grid container>
                    <Grid item xs={12}>
                    {mode=="view" && (
                    <FormikFormField
                      type="text"
                      label={department.label}
                      name={department.name}
                      disabled={mode === "view"}
                      value={t(departmentV)}
                    />
                    )}  
                    {mode!="view" && (
                    <FormikFormField                                    
                    label={department.label}
                    name={department.name}
                    value={selectedDepartment}
                    disabled={mode === "view"}
                    component={SuiSelect}                                    
                    defaultValue={departmentV}
                    options={departmentOptions}
                    onChange={(option) => {
                        setSelectedDepartment(option);
                        setFieldValue(department.name, option.value);
                        }}
                    />
                    )}
                    {mode=="view" && (
                    <FormikFormField
                      type="text"
                      label={position.label}
                      name={position.name}
                      disabled={mode === "view"}
                      value={t(positionV)}
                    />
                    )}  
                    {mode!="view" && departmentV!="Admin" && (
                    <FormikFormField                                    
                    label={position.label}
                    name={position.name}
                    value={selectedPosition}
                    disabled={mode === "view"}
                    component={SuiSelect}
                    defaultValue={positionV}
                    options={positionOptions}                                    
                    onChange={(option) => {
                        setSelectedPosition(option);
                        setFieldValue(position.name, option.value);
                        }}
                    />
                    )}
                    {mode!="view" && departmentV=="Admin" && (
                    <FormikFormField
                    type="text"
                    label={position.label}
                    name={position.name}
                    disabled="false"
                    value={t("Admin")}
                    />
                    )}                    
                    </Grid>
                    </Grid>
                </SuiBox>
                  <Grid item xs={12}>
                    <SuiBox display="flex" justifyContent="flex-end" mt={3}>
                    <SuiButton onClick={history.goBack} style={{ marginRight: 15 }}>
                        {t("Cancel")}
                    </SuiButton>
                    {mode !== "view" && (
                    <SuiButton
                        variant="gradient"
                        color="info"
                        disabled={Object.entries(errors).length}
                        onClick={submitForm}
                    >
                        {t(isEditing ? "Update" : "Create")}
                    </SuiButton>
                    )}
                    {mode === "view" && <span />}
                    </SuiBox>                  
                  </Grid>
                </SuiBox>
              </Card>
              </Form>
            );
            }}
              </Formik>
              )}
            </Grid>            
          </Grid>
        </SuiBox>
        <Footer />
      </DashboardLayout>
    </>
  );
}

export default NewOrEditAdminUser;
